import { Clock, FileText, CheckCircle, XCircle } from "lucide-react";

export const getStatusIcon = (statusLabel: string) => {
  const label = statusLabel.toLowerCase();
  if (label.includes("new") || label.includes("pending")) return Clock;
  if (label.includes("progress") || label.includes("process")) return FileText;
  if (label.includes("done") || label.includes("complete") || label.includes("approved"))
    return CheckCircle;
  if (label.includes("reject") || label.includes("cancel")) return XCircle;
  return FileText;
};

export const getStatusColor = (statusLabel: string) => {
  const label = statusLabel.toLowerCase();
  if (label.includes("new") || label.includes("pending")) {
    return {
      bg: "bg-gray-100 dark:bg-gray-700",
      text: "text-gray-600 dark:text-gray-400",
    };
  }
  if (label.includes("progress") || label.includes("process")) {
    return {
      bg: "bg-blue-100 dark:bg-blue-900/30",
      text: "text-blue-600 dark:text-blue-400",
    };
  }
  if (label.includes("done") || label.includes("complete") || label.includes("approved")) {
    return {
      bg: "bg-green-100 dark:bg-green-900/30",
      text: "text-green-600 dark:text-green-400",
    };
  }
  if (label.includes("reject") || label.includes("cancel")) {
    return {
      bg: "bg-red-100 dark:bg-red-900/30",
      text: "text-red-600 dark:text-red-400",
    };
  }
  return {
    bg: "bg-purple-100 dark:bg-purple-900/30",
    text: "text-purple-600 dark:text-purple-400",
  };
};